<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Product Batch Numbers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Product Batch Numbers",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Product Batch Numbers",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "batch",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "days_field",
          sortable: true,
          label: "DAYS TO EXPIRE",
        },
        {
          key: "expiry",
          sortable: true,
          label: "EXPIRY DATE",
        },
        {
          key: "actions",
          sortable: true,
          label: "Actions",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product.name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "batch",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "days_field",
          sortable: true,
          label: "DAYS TO EXPIRE",
        },
        {
          key: "expiry",
          sortable: true,
          label: "EXPIRY DATE",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "actions",
          sortable: true,
          label: "Actions",
        },
      ],

      filterBatches:{
        category:'',
        product:''
      },

      // edit item
      editdata: {
        id: "",
        product: "",
        batchnumber: "",
        expiry_date: "",
        filterdata:{}
      },

      // delete item
      deletedata: {
        product: "",
        batchnumber:"",
        id: "",
        filterdata:{}
      },

      batchError:"",
      dateError:"",

    };
  },

  watch:{
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("stock", ["Batches","FilterStatus","SaveStatus"]),
    ...mapGetters("auth", ["branchid","Branches","MyUserPerm"]),
    ...mapGetters("products", ["Categories"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Batches ? this.Batches.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Batches ? this.Batches.length : 1;
  },

  methods: {
    ...mapActions({
      FetchBatches: "stock/fetchBatches",
      EditBatches: "stock/editBatches",
      DeleteBatches: "stock/deleteBatches",
      FetchCategories: "products/fetchPCategories",
    }),

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },


    resetDeleteItem() {
      this.closeModal(this.modal_id);
      this.deletedata.product = "";
      this.deletedata.batchnumber = "";
      this.deletedata.id = "";
    },

    resetEdit() {
      this.closeModal(this.modal_id);
      this.editdata.product = "";
      this.editdata.id = "";
      this.editdata.expiry_date = "";
      this.editdata.batchnumber = "";
    },

    resetErrors() {
      this.batchError = "";
      this.dateError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.type == 2?data.product.name:data.product.product_name;
      this.editdata.id = data.id;
      this.editdata.expiry_date = data.expiry;
      this.editdata.batchnumber = data.batch;
    },

    showDeleteModal(data) {
      this.deletedata.batchnumber = data.batch;
      this.deletedata.product = data.type == 2?data.product.name:data.product.product_name;
      this.deletedata.id = data.id;
    },

    editBatches(modalId) {
      this.modal_id = modalId;
      this.editdata.filterdata = this.filterBatches;
      this.EditBatches(this.editdata);
    },

    deleteBatches(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.filterBatches;
      this.DeleteBatches(this.deletedata);
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    FilterBatches(){
      this.FetchBatches(this.filterBatches);
    }
  },
  created() {
    this.FetchBatches(this.filterBatches);
    this.FetchCategories();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8">
                <h5 class="text-warning">Product batch numbers</h5>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-md-4 form-group mb-2">
                <label>SEARCH BY CATEGORY</label>
                
                <model-list-select
                  :list="Categories ? Categories : []"
                  v-model="filterBatches.category"
                  option-value="id"
                  option-text="catName"
                  placeholder="Select Category"
                  @input="FilterBatches()"
                >
                </model-list-select>
              </div>
              <div class="col-md-4 form-group">
                Search Product
                <div class="input-group">
                <input
                  v-model="filterBatches.product"
                  type="text"
                  class="form-control"
                  @keyup.enter="FilterBatches()"
                /> 
                <div class="input-group-append">
                  <button class="btn btn-primary" type="button" @click="FilterBatches()">
                    
                    <b-spinner
                      v-if="FilterStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>

                  <span>Search</span>
                  
                  </button>
                </div>
                
              </div>              
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Batches ? Batches : []"
                :fields="branchid==0?fields1:fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(days_field)="data"> {{ data.item.days }} days </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    v-if="MyUserPerm.edit_batch_numbers == 1"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    @click="showEditModal(data.item)"
                    ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                    v-if="MyUserPerm.delete_batch_numbers == 1"
                    v-b-modal.delete-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteModal(data.item)"
                    ><i class="fa fa-trash"></i></b-button
                  >
                </template>
              </b-table>
            </div>
            <center>
                <Loader v-if="!Batches" />
            </center>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- modal edit item starts -->
            <b-modal id="edit-item-modal" class="text-primary" hide-footer @hidden="resetEdit()">
            <template #modal-title>
                Edit Item batch number {{ deletedata.batchnumber }} for item {{ deletedata.product }}</template
            >
            <div class="form-group mb-3">
                <label>Batch Number</label>
                <input type="text" class="form-control" v-model="editdata.batchnumber" />
            </div>
            <div class="form-group mb-3">
                <label>Expiry Date</label>
                <input type="date" class="form-control" v-model="editdata.expiry_date" />
            </div>
            <div class="modal-footer">
                <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('edit-item-modal')"
                >
                <i class="fa fa-times"></i> Close
                </button>
                <button
                type="button"
                class="btn btn-primary"
                @click="editBatches('edit-item-modal')"
                >
                <i class="fa fa-check"></i> Save Changes
                <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Editing"
                ></b-spinner>
                </button>
            </div>
            </b-modal>
            <!-- modal ends -->
            <!-- modal delete expense starts -->
            <b-modal id="delete-item-modal" class="text-danger" hide-footer @hidden="resetDeleteItem">
            <template #modal-title> Delete batch number {{ deletedata.batchnumber }} for {{ deletedata.product }} </template>
            <div class="form-group mb-3">
                <div class="input-group">
                <h5>Do you want to remove this batch number? Click Proceed to continue.</h5>
                </div>
            </div>
            <div class="modal-footer">
                <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="closeModal('delete-item-modal')"
                >
                <i class="fa fa-times"></i> Close
                </button>
                <button
                type="button"
                class="btn btn-danger"
                @click="deleteBatches('delete-item-modal')"
                >
                <i class="fa fa-trash"></i> Proceed
                <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Deleting"
                ></b-spinner>
                </button>
            </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
